/** Higher number = higher privilege (header shows the top role only). */
const ROLE_RANK: Record<string, number> = {
  'system administrator': 100,
  'hr manager': 90,
  'payroll officer': 80,
  'accountant': 70,
  'department manager': 60,
  employee: 10,
};

function roleRank(name: string): number {
  return ROLE_RANK[name.trim().toLowerCase()] ?? 50;
}

/**
 * Picks the highest-privilege role for header display.
 * Accepts either discrete role names or a legacy comma-joined RoleName string.
 */
export function pickPrimaryRoleName(roleNames: string | string[] | null | undefined): string {
  const names = (Array.isArray(roleNames) ? roleNames : (roleNames ?? '').split(','))
    .map((n) => n.trim())
    .filter(Boolean);

  if (names.length === 0) return '';

  const unique = [...new Map(names.map((n) => [n.toLowerCase(), n])).values()];
  unique.sort((a, b) => {
    const rankDiff = roleRank(b) - roleRank(a);
    return rankDiff !== 0 ? rankDiff : a.localeCompare(b);
  });
  return unique[0];
}
